import React from "react";
import { HorizontalLayout } from "../components/layout";

export function IconTextMolecule({ icon, text, style, className }) {
    return (
        <HorizontalLayout
        className={`${className}`}
            style={{ alignItems: "center", gap: "0.75rem", marginTop: "0.75rem", ...style }}
        >
            {icon}
            {text}
        </HorizontalLayout>
    );
}